import { Injectable } from '@angular/core';

import { BehaviorSubject, Subscription } from 'rxjs';

import { DocumentoVenda } from 'src/app/model/documentoVenda/documentoVenda';
import { DocumentoVendaDataService } from 'src/app/core/services/documentoVenda-crud.service';

@Injectable()
export class DocumentoVendaService {

  //#region BehaviorSubject Objects sources
  private documentos = new BehaviorSubject<DocumentoVenda>(null);
  //#endregion

  //#region data-services handlers
  private handlerDocumentos: Subscription;
  //#endregion

  //#region BehaviorSubject subcribables by the components
  public documentos$ = this.documentos.asObservable();
  //#endregion

  //#region Primary Key Properties
  private id: number;
  //#endregion

  //#region Data Properties
  private documentosData: DocumentoVenda;
  //#endregion

  constructor(private vendasDataService: DocumentoVendaDataService) {
  }

  public setPrimaryKey = (id: number): void => {
    this.id = id;

    // clear data properties
    this.documentosData = null;

    if (this.handlerDocumentos) { this.getDocumentoVenda(id); }
  }

  //#region Getters
  private getDocumentoVenda = (id: number): void => {
    this.handlerDocumentos = this.vendasDataService
      .get(id)
      .subscribe(response => {
        this.documentosData = response;
        this.documentos.next(this.documentosData);
      },
        error => console.log(error),
        () => {
        });
  }
  //#endregion

  //#region Subscribers
  public documentoVendaSubscribe = (func: any): void => {
    this.documentos$.subscribe(func);

    // one subscriber => load the data, if not loaded and not requested
    if (!this.documentosData && this.id && this.handlerDocumentos == null) {
      this.getDocumentoVenda(this.id);
    }
  }
  //#endregion
}
